module.exports = __webpack_public_path__ + "img/SL7_4564-Bearbeitet.806225c4.jpg";